export default __webpack_public_path__ + "static/media/Group11@0.5x.bcfa4090.svg";